import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "inputField"]

  connect() {
    if (this.hasCheckboxTarget) {
      if (this.checkboxTarget.checked) {
        this.inputFieldTargets.forEach((inputFeild) => {
          inputFeild.classList.remove("sm:hidden")
          inputFeild.classList.remove("hidden")
        })
      }
    }
  }

  toggleFields() {
    if (this.hasCheckboxTarget) {
      if (this.checkboxTarget.checked) {
        this.inputFieldTargets.forEach((inputFeild) => {
          inputFeild.classList.remove("sm:hidden")
          inputFeild.classList.remove("hidden")
        })
      } else {
        this.inputFieldTargets.forEach((inputFeild) => {
          inputFeild.classList.add("sm:hidden")
          inputFeild.classList.add("hidden")
        })
      }
    }
  }
}
